class HeaderSearch extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['input']
  }

  static get matches () {
    return {
      input: '[data-header-search-el="input"]',
      close: '[data-header-search-el="close"]',
      trigger: '[data-header-search-external-el="trigger"]',
      klevu: '.klevu-fluid',
      iconSearch: '.hd-Search_Icon-search',
      searchRoot: 'header-search',
    }
  }

  static get bodyListeners () {
    if (!HeaderSearch._bodyListeners) {
      HeaderSearch._bodyListeners = new window.BAO.Listeners()
    }

    return HeaderSearch._bodyListeners
  }

  static get classes () {
    return {
      searchFocus: 'util-SearchFocus',
    }
  }

  get config () {
    return {
      matches: this.constructor.matches,
      classes: this.constructor.classes,
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onInputFocus = this.onInputFocus.bind(this)
    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onCloseClick = this.onCloseClick.bind(this)

    if (!this.els?.input?.exists) return

    this.listeners.add(this.els.input.element, 'focus', this.onInputFocus)

    if (this.els?.close?.exists) {
      this.els.close.elements.forEach(closeEl => {
        this.listeners.add(closeEl, 'click', this.onCloseClick)
      })
    }

    if (this.externalEls?.trigger?.exists) {
      this.externalEls.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, 'click', this.onTriggerClick)
      })
    }

    if (!HeaderSearch._bodyClickAttached) {
      HeaderSearch._bodyClickAttached = true

      HeaderSearch.bodyListeners.add(
        document.body,
        'click',
        HeaderSearch.handleBodyClick,
      )
    }
  }

  onInputFocus () {
    document.body.classList.add(this.config.classes.searchFocus)
  }

  onTriggerClick () {
    document.body.classList.add(this.config.classes.searchFocus)
    this.els.input.element.focus()
  }

  onCloseClick () {
    this.els.input.element.blur()
    document.body.classList.remove(this.config.classes.searchFocus)
  }

  static handleBodyClick (e) {
    if (HeaderSearch.isSearchInteraction(e.target)) return

    document.body.classList.remove(HeaderSearch.classes.searchFocus)
  }

  static isSearchInteraction (target) {
    return Object.values(HeaderSearch.matches).some(
      selector => target.closest(selector) !== null,
    )
  }
}

if (!customElements.get('header-search')) {
  customElements.define('header-search', HeaderSearch)
}
